<template>
    <div class="min-h-screen bg-a-egg-f5ebdc">
        <div class="p-6">
            <img class="m-auto mt-7 logo-width" src="../../../assets/logo/Logo.svg">
            <img class="m-auto mt-7 w-9" src="../../../assets/success/ic-complete-brown.svg">
            <div class="text-center text-24 text-a-brown-502314 font-bold mt-3">{{lbl.register.register_completed}}</div>
            <div class="mt-3 text-16 text-a-brown-502314 text-center">
                {{lbl.register.Now_you}} <span class="font-bold">{{lbl.register.burgerking}}</span> {{lbl.register.enjoy_your_meal}}
            </div>
            <div class="mt-8 btn-width m-auto">
                <RedButton @click="checkTraces()">{{lbl.register.start_your_order}} </RedButton>
            </div>
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility'
import Account from '@/helper/AccountHelper.js';
import CacheHelper from '@/helper/CacheHelper';
import { CacheKey } from '@/helper/StaticValue';
// component
import RedButton from '@/components/Button/RedButton.vue'
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from "@/mixin/ModalMixin"

export default {
    mixins: [LocaleMixin,ModalMixin],
    components: {
        RedButton,
    },
    data: function () {
        return {
            pathAfterLogin: null,
        };
    },
    created: function() {
        let afterLogin = this.$route.query.afterLogin;
        if (!Util.isEmptyStr(afterLogin)) {
            this.pathAfterLogin = afterLogin;
        }
        this.loadCacheTracesBadges();
    },
    methods: {
        afterRegisterRedirect: function () {
            if (this.pathAfterLogin == null) {
                window.location.replace('/home');
                // this.$router.replace('/home');
            } else {
                window.location.replace(this.pathAfterLogin);
                // this.$router.replace(this.pathAfterLogin);
            }
        },
        checkTraces: function () {
            if (this.traces && this.traces.length > 0) {
                this.modal.tracesModal.clearModal()
                                .setPoint(this.traces[0].Points)
                                .show();
                this.modal.tracesModal.onClickOk(()=> {
                    this.checkBadges();
                });            
            }  else {
                this.checkBadges();
            } 
        },
        checkBadges: function () {
            if (this.badges && this.badges.length > 0) {
                this.modal.badgesModal.clearModal()
                                .setCampaignId(this.badges[0].auto_redeem.CampaignId)
                                .setCampaignName(this.badges[0].auto_redeem.CampaignName)
                                .show();
                this.modal.badgesModal.onClickOk(()=> {
                    window.location.replace('/mycoupon');
                });   
            } else {
                if (this.traces && this.traces.length > 0) {
                    window.location.replace('/mycoupon');
                } else {
                    this.afterRegisterRedirect();
                }
            }
        },
        loadCacheTracesBadges: function () {
            let cache = new CacheHelper('session');
            let CacheTraces = cache.getCache(CacheKey.traces);
            // let CacheBadges = cache.getCache(CacheKey.Badges);
            if (CacheTraces != null) {
                this.traces = CacheTraces;
                console.log(this.traces);
                this.clearCacheTracesBadges();
            }

            let account = Account.getCacheUser();
            if (account && account.buzzebees && account.buzzebees.badges) {
                this.badges = account.buzzebees.badges;
                console.log(this.badges);
            }
            
        },
        clearCacheTracesBadges: function () {
            let cache = new CacheHelper('session');
            cache.removeCache(CacheKey.traces)
        },
    },
}
</script>
<style lang="scss" scoped>
    .logo-width {
        width: 80px;
    }
    .btn-width {
        max-width: 255px;
    }
</style>
